// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"e41888d0","198":"ea406cc6","496":"902e6810","885":"80cd8503"}[chunkId] + ".chunk.js";
};